import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './RevenueCenters.css';

const RevenueCentersReportForm = () => {
  const [formData, setFormData] = useState({
    startDate: '2026-09-01',
    endDate: '2026-09-30',
    excludeMaterials: false,
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="rc-wrap">
      {/* Top Heading */}
      <div className="rc-desc">Revenue distribution by revenue center.</div>

      <div className="rc-box">
        {/* Parameters Section Header */}
        <h2 className="rc-title">Parameters</h2>

        {/* Main Form Box */}
        <form onSubmit={handleSubmit} className="rc-panel">
          {/* Start Date */}
          <div className="rc-row">
            <label className="rc-label" htmlFor="startDate">
              Start Date <span className="rc-req">*</span>
            </label>
            <input
              id="startDate"
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              required
              className="rc-input rc-date"
            />
          </div>

          {/* End Date */}
          <div className="rc-row">
            <label className="rc-label" htmlFor="endDate">
              End Date <span className="rc-req">*</span>
            </label>
            <input
              id="endDate"
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              required
              className="rc-input rc-date"
            />
          </div>

          {/* Exclude Materials Checkbox */}
          <div className="rc-row">
            <span className="rc-label" />
            <label className="rc-check" htmlFor="excludeMaterials">
              <input
                type="checkbox"
                id="excludeMaterials"
                name="excludeMaterials"
                checked={formData.excludeMaterials}
                onChange={handleChange}
              />
              Exclude Materials and Alloys?
            </label>
          </div>

          {/* Format Selection */}
          <div className="rc-row">
            <label className="rc-label" htmlFor="format">
              Format <span className="rc-req">*</span>
            </label>
            <select
              id="format"
              name="format"
              value={formData.format}
              onChange={handleChange}
              required
              className="rc-input rc-select"
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </select>
          </div>

          {/* Submit Button */}
          <div className="rc-row rc-row-run">
            <span className="rc-label" />
            <Link to="/AddRevenuecenter" className="rc-link">
              <button id="pay-per-task-submit" type="button" className="rc-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RevenueCentersReportForm;